"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../../util/makeStyles"));
var styleUtilities_1 = require("../../../../util/styleUtilities");
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        root: {
            minHeight: 0,
        },
        topConnector: {},
        bottomConnector: {},
        dotRoot: {
            marginTop: 0,
            marginBottom: 0,
            padding: 1,
            boxShadow: 'none',
        },
        dotRootSmall: {
            padding: 0,
        },
        inactiveBackground: {
            backgroundColor: (0, styleUtilities_1.withOpacity)(theme_1.default.colors.dark, 0.2),
        },
        allItemsInactiveBackground: {
            backgroundColor: (0, styleUtilities_1.withOpacity)(theme_1.default.colors.dark, 0.5),
        },
        activeBackground: {
            backgroundColor: theme_1.default.colors.tertiary,
        },
        contentRoot: {
            margin: 'auto 0',
            padding: '12px 16px',
        },
        contentRootSmall: {
            padding: '8px 16px',
        },
        label: {},
        amendment: {
            marginTop: 4,
        },
        description: {
            marginTop: 2,
        },
        connectorHidden: {
            visibility: 'hidden',
        },
        contentHidden: {
            '&::before': {
                content: 'none',
            },
        },
    });
});
